export const USER_ROLES = {
  broker: 'BROKER',
  brokerEs: 'BROKER_ES',
};

export const BUSINESS_IDENTIFIER = {
  ES_BAYTECA: 'ES_BAYTECA',
  AE_HUSPY: 'AE_HUSPY',
} as const;

export const TRANSACTION_ACTION_TYPES = {
  proposalGenerated: 'hub.proposal.generated',
  opportunitySubmitted: 'hub.opportunity.submitted',
  firstBankApplicationToHuspySubmitted: 'hub.bank-application.submitted.huspy.first',
  secondBankApplicationToHuspySubmitted: 'hub.bank-application.submitted.huspy.second',
  otherBankApplicationToHuspySubmitted: 'hub.bank-application.submitted.huspy.others',
  firstBankApplicationDirectToBankSubmitted: 'hub.bank-application.submitted.direct-to-bank.first',
  otherBankApplicationDirectToBankSubmitted: 'hub.bank-application.submitted.direct-to-bank.others',
  allocateCredits: 'allocate.credit',
  refundCredits: 'refund.credit',
  deductCredits: 'deduct.credit',
  allocateCreditsPurchased: 'allocate.credit.purchased',
  refundCreditsPurchased: 'refund.credit.purchased',
  deductCreditsExpired: 'expire.credit',
} as const;

export const CREDITS_CHARGE_ACTION_TYPES = {
  proposalGenerate: TRANSACTION_ACTION_TYPES.proposalGenerated,
  firstBankApplicationToHuspySubmit: TRANSACTION_ACTION_TYPES.firstBankApplicationToHuspySubmitted,
  secondBankApplicationToHuspySubmit: TRANSACTION_ACTION_TYPES.secondBankApplicationToHuspySubmitted,
  otherBankApplicationToHuspySubmit: TRANSACTION_ACTION_TYPES.otherBankApplicationToHuspySubmitted,
  firstBankApplicationDirectToBankSubmit: TRANSACTION_ACTION_TYPES.firstBankApplicationDirectToBankSubmitted,
  otherBankApplicationDirectToBankSubmit: TRANSACTION_ACTION_TYPES.otherBankApplicationDirectToBankSubmitted,
} as const;
